import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Play, RotateCcw, Home } from "lucide-react";

interface ResumeWorkoutDialogProps {
  isOpen: boolean;
  sessionAge: string | null;
  onResume: () => void;
  onStartFresh: () => void;
  onGoHome: () => void;
}

export const ResumeWorkoutDialog = ({
  isOpen,
  sessionAge,
  onResume,
  onStartFresh,
  onGoHome,
}: ResumeWorkoutDialogProps) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && onStartFresh()}>
      <AlertDialogContent className="max-w-sm w-[calc(100%-2rem)]">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-center">
            Entrenamiento en progreso
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            Tienes un entrenamiento guardado {sessionAge && `(${sessionAge})`}. 
            ¿Quieres continuar donde lo dejaste?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex flex-col items-center gap-4 w-full sm:flex-col">
          <AlertDialogAction
            onClick={onResume}
            className="w-full bg-primary hover:bg-primary/90"
          >
            <Play className="w-4 h-4 mr-2" />
            Continuar entrenamiento
          </AlertDialogAction>
          <Button
            variant="outline"
            onClick={onStartFresh}
            className="w-full"
          >
            <RotateCcw className="w-4 h-4 mr-2" />
            Empezar de nuevo
          </Button>
          <Button
            variant="ghost"
            onClick={onGoHome}
            className="w-full"
          >
            <Home className="w-4 h-4 mr-2" />
            Volver a inicio
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
